module.exports = __webpack_public_path__ + "static/media/perfect_money_logo.46b45651.svg";